export enum BuildEnvironmentKind {
  Development = "Development",
  Staging = "Staging",
  Production = "Production"
}
